import { DefaultFilterConfig } from 'app/area/shared/default-filters/types';

export const languageValidationParameter = 'description';

export const maxDescriptionLength = 254;

export const userGroupCodetableId = 19;

export const limitedByUsersAccess = 1;

export const DashboardComponentForm = 'form';

export const defaultFilterDashboardConfig: DefaultFilterConfig = {
  showRequired: false
};
